import { useSelector, useDispatch } from 'react-redux';
import User from '../user';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import { getAllOrderAPI } from '../../apis/order';
import { useEffect, useState } from 'react';
import { Card, List, Pagination, Switch, Button, message } from 'antd';
import logo from '../../assets/logo.png';
import OrderStatusTag from '../OrderStatusTag';
import { addCart, addComboToCart } from '../../store/modules/takeaway';
import PurchaseHistoryComboItem from './PurchaseHistoryComboItem';

const PurchaseHistory = () => {
  const { userInfo } = useSelector((state: any) => state.user);
  const { cartList } = useSelector((state: any) => state.foods);
  const dispatch = useDispatch();
  // dispatch(removeCartItem({ itemId }));
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(4);
  const [visible, setVisible] = useState({});
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };
  const handleLogoClick = () => {
    navigate('/');
  };

    // 更稳健地根据 ctime（MM-DD HH:mm）和 oid 提取年份来排序
    const parseOrderDate = (order: any) => {
      // 尝试从 oid 提取年份（oid 形如 202512230001）
      const oidStr = String(order.oid || '');
      const year = oidStr.length >= 4 ? parseInt(oidStr.slice(0, 4), 10) : new Date().getFullYear();
  
      // 匹配 "MM-DD HH:mm" 或 "MM-DD HH: mm" 等格式
      const m = String(order.ctime || '').match(/(\d{2})-(\d{2})\s+(\d{1,2}):\s*(\d{2})/);
      if (m) {
        const month = parseInt(m[1], 10);
        const day = parseInt(m[2], 10);
        const hour = parseInt(m[3], 10);
        const minute = parseInt(m[4], 10);
        return new Date(year, month - 1, day, hour, minute);
      }
  
      // 兜底：尝试标准解析，失败时返回极早的时间
      const d = new Date(order.ctime);
      return isNaN(d.getTime()) ? new Date(0) : d;
    };
  
    const paginatedOrders = [...orders]
      .sort((a, b) => parseOrderDate(b).getTime() - parseOrderDate(a).getTime())
      .slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const handleToggleVisibility = (oid) => {
    setVisible((prevVisible) => ({
      ...prevVisible,
      [oid]: !prevVisible[oid],
    }));
  };


  const handleReorder = (foodItem) => {
    // cartListの中に同じnameとflavorsの項目があるかどうかを確認する
    const existingItem = cartList.find(
      (item) => item.name === foodItem.name && item.flavors === foodItem.flavor
    );

    if (existingItem) {
      // 既存の項目がある場合、その項目のcountを1増やす
      dispatch(
        addCart({
          ...existingItem,
          count: existingItem.count + 1,
        })
      );
      message.success('再度購入しました'); // 成功メッセージを表示する
    } else if (foodItem.comboId !== null) {
      dispatch(addComboToCart({
        id: foodItem.food_id,
        picture: foodItem.file_path,
        name: foodItem.name,
        price: foodItem.price,
        count: 1,
        flavors: '',
        comboId: foodItem.comboId,
        selectedItems: [
          { foods: foodItem.comboRows }
        ],
      }));
      message.success('再度購入しました'); // 成功メッセージを表示する
    } else {
      // 新しい項目を作成し、cartListに追加する
      const newId = foodItem.flavor ? `${foodItem.food_id}(${foodItem.flavor})` : `${foodItem.food_id}`;
      dispatch(
        addCart({
          id: newId,
          picture: foodItem.file_path,
          name: foodItem.name,
          price: foodItem.price,
          count: 1,
          flavors: foodItem.flavor || '',
        })
      );
      message.success('再度購入しました'); // 成功メッセージを表示する
    }
  }
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        console.log('userInfo:', userInfo.userId); // 添加日志
        const response = await getAllOrderAPI(userInfo.userId);
        console.log('response:', response); // 添加日志
        if (response.success) {
          setOrders(response.result.orders);
          console.log('orders:', response.result.orders); // 添加日志
          // 初始化 visible 状态，使所有订单的 List 组件内容都显示
          const initialVisibleState = response.result.orders.reduce(
            (acc, order) => {
              acc[order.oid] = true;
              return acc;
            },
            {}
          );
          setVisible(initialVisibleState);
        } else {
          setOrders([]);
        }
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    };

    if (userInfo.userId) {
      fetchOrders();
    }
  }, [userInfo.userId]);

  return (
    <div className="purchaseHistoryContainer">
      <div className="scrollArea">
        <div className="header">
          <div className="backToTop">
            <img
              className="login-logo"
              src={logo}
              alt=""
              onClick={handleLogoClick}
            />
          </div>
          <span className="text">購入履歴</span>
          <User></User>
        </div>
        <div className="order-container">
          {paginatedOrders.length === 0 ? (
            <Card title="過去の購入履歴がありません" style={{ marginBottom: 16 }} />
          ) : (paginatedOrders.map((order) => (
            <Card
              key={order.oid}
              title={`注文番号: ${order.oid}`}
              style={{ marginBottom: 16 }}
              extra={
                <div>
                  <OrderStatusTag status={order.status} />
                  <Switch
                    checked={visible[order.oid]}
                    onChange={() => handleToggleVisibility(order.oid)}
                    style={{ marginRight: 8 }}
                  />
                </div>
              }
            >
              <p>合計金額: {Number(order.amount).toLocaleString()} 円</p>
              <p>注文日時: {order.ctime}</p>
              {visible[order.oid] && (
                <List
                  itemLayout="horizontal"
                  dataSource={order.orderFoodItems}
                  renderItem={(foodItem: any) => (
                    <List.Item>
                      <img
                        className="shopPic"
                        src={foodItem.file_path}
                        alt=""
                      />
                      <List.Item.Meta
                        title={`料理名: ${foodItem.name}`}
                        description={
                          <>
                            <p>注文数量: {foodItem.quantity}</p>
                            {foodItem.flavor && <p>風味: {foodItem.flavor}</p>}
                            <p>
                              価格: {Number(foodItem.price).toLocaleString()} 円
                            </p>
                            <Button type="primary" onClick={() => handleReorder(foodItem)}>
                              再度購入
                            </Button>
                            {foodItem.comboId !== null && foodItem.comboRows &&
                              <PurchaseHistoryComboItem selectedItems={foodItem.comboRows} />
                            }
                          </>
                        }
                      />
                    </List.Item>
                  )}
                />
              )}
            </Card>
          )))}
        </div>
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={orders.length}
          onChange={handlePageChange}
          style={{ textAlign: 'center', marginTop: 16 }}
        />
      </div>
    </div>
  );
};

export default PurchaseHistory;
